import {
  createModalStack,
  ModalOptions,
  ModalStackConfig,
} from 'react-native-modalfy';

import { IS_WEB } from '@utils';
import { DEFAULT_ANIMATION } from './animations';
import { ModalStackParamsType } from './types';
import { modals } from './modals';
import { ImagePickerModal } from '../components/modals/ImagePickerModal';
import { TimestampsModal } from '../components/modals/TimestampsModal';
import { ConfirmationModal } from '../components/modals/ConfirmationModal';
import { AlertModal } from '../components/modals/AlertModal';
import { AllowNotificationsModal } from '../components/modals/AllowNotificationsModal';
import { InviteSuggestionModal } from '../components/modals/InviteSuggestionModal';
import { ChangeSubscriptionPlanModal } from '../components/modals/ChangeSubscriptionPlanModal';
import { AddCreditCardModal } from '../components/modals/AddCreditCardModal';
import { SubscribeSuggestionModal } from '../components/modals/SubscribeSuggestionModal';
import { MobileAppSuggestionModal } from '../components/modals/MobileAppSuggestionModal';
import { PostEditorModal } from '../components/modals/PostEditorModal';
import { PostViewModal } from '../components/modals/PostViewModal';
import { ReportModal } from '../components/modals/ReportModal';
import { OptionsMenuModal } from '../components/modals/OptionsMenuModal';
import { PickerModal } from '../components/modals/PickerModal';
import { LikesModal } from '../components/modals/LikesModal';
import { TrackFeedbackFormModal } from '../components/modals/TrackFeedbackFormModal';
// eslint-disable-next-line max-len
import { ChooseTrackFeedbackOptionModal } from '../components/modals/ChooseTrackFeedbackOptionModal';
import { PurchaseCreditsModal } from '../components/modals/PurchaseCreditsModal';
import { LoaderModal } from '../components/modals/LoaderModal';

const modalConfig: ModalStackConfig = {
  [modals.ImagePickerModal]: {
    modal: ImagePickerModal,
    position: IS_WEB ? 'center' : 'bottom',
  },
  [modals.TimestampsModal]: {
    modal: TimestampsModal,
    position: 'bottom',
  },
  [modals.ConfirmationModal]: {
    modal: ConfirmationModal,
  },
  [modals.AllowNotificationsModal]: {
    modal: AllowNotificationsModal,
    position: 'bottom',
  },
  [modals.AlertModal]: {
    modal: AlertModal,
  },
  [modals.InviteSuggestionModal]: {
    modal: InviteSuggestionModal,
    position: IS_WEB ? 'center' : 'bottom',
  },
  [modals.ChangeSubscriptionPlanModal]: {
    modal: ChangeSubscriptionPlanModal,
  },
  [modals.AddCreditCardModal]: {
    modal: AddCreditCardModal,
  },
  [modals.SubscribeSuggestionModal]: {
    modal: SubscribeSuggestionModal,
    position: IS_WEB ? 'center' : 'bottom',
  },
  [modals.MobileAppSuggestionModal]: {
    modal: MobileAppSuggestionModal,
    position: 'bottom',
  },
  [modals.PostEditorModal]: {
    modal: PostEditorModal,
    position: IS_WEB ? 'center' : 'bottom',
  },
  [modals.PostViewModal]: {
    modal: PostViewModal,
    position: 'center',
  },
  [modals.ReportModal]: {
    modal: ReportModal,
  },
  [modals.OptionsMenuModal]: {
    modal: OptionsMenuModal,
    position: 'bottom',
  },
  [modals.PickerModal]: {
    modal: PickerModal,
    position: 'bottom',
  },
  [modals.LikesModal]: {
    modal: LikesModal,
    position: 'center',
  },
  [modals.TrackFeedbackFormModal]: {
    modal: TrackFeedbackFormModal,
    position: 'center',
  },
  [modals.PurchaseCreditsModal]: {
    modal: PurchaseCreditsModal,
    position: 'center',
  },
  [modals.ChooseTrackFeedbackOptionModal]: {
    modal: ChooseTrackFeedbackOptionModal,
    position: 'center',
  },
  [modals.LoaderModal]: {
    modal: LoaderModal,
    position: 'center',
    backBehavior: 'none',
  },
};

const defaultOptions: ModalOptions = {
  backdropOpacity: 0.4,
  position: 'center',
  ...DEFAULT_ANIMATION,
};

export const modalStack = createModalStack<ModalStackParamsType>(
  modalConfig,
  defaultOptions,
);
